module.exports = __webpack_public_path__ + "static/mobileApps-88f56356cd85d79d31a78e2579347d1a.png";